import React, { useEffect } from "react";

function ImportScript(props) {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = props.src;
        script.async = true;
        document.body.appendChild(script);

        return () => document.body.removeChild(script);
    }, [props.src]);

    return null;
}

export default ImportScript;
